// src/Header.js
import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { FaCog } from "react-icons/fa";
import { branding, isDemoBuild } from "./siteConfig.js";
import NavDrawer from "./NavDrawer.js";
import HeaderToolbar from "./HeaderToolbar.js";

function Header({ onLoginClick, isPublic, user, isAdmin, onLogout, isMobile }) {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const navigate = useNavigate();

  const toggleMenu = (e) => {
    e.stopPropagation();
    setIsMenuOpen(!isMenuOpen);
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  const handleNavigate = (path) => {
    navigate(path);
    closeMenu();
  };

  const handleLogout = () => {
    onLogout();
    closeMenu();
  };

  return (
    <header className="header">
      <div className="header-content">
        <button
          type="button"
          className={`hamburger-button${isMenuOpen ? " hamburger-button--open" : ""}`}
          onClick={(e) => toggleMenu(e)}
          aria-expanded={isMenuOpen}
          aria-controls="site-nav-drawer"
          aria-label={isMenuOpen ? "Close menu" : "Open menu"}
        >
          <span className="hamburger-icon" aria-hidden="true" />
        </button>
        <div className="header-title-container">
          <h1 className="header-title">{branding.siteName}</h1>
          {user && (
            <div style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
              <p className={`header-user ${isAdmin ? "text-red-500" : "text-gray-300"}`}>
                Logged in as: {user.email} {isAdmin && "(Admin)"}
              </p>
              <Link to="/preferences" style={{ marginLeft: "10px", color: "white", cursor: "pointer" }}>
                <FaCog />
              </Link>
            </div>
          )}
        </div>
        {isPublic ? (
          <button type="button" onClick={onLoginClick} className="header-login-button">
            {isDemoBuild ? "Demo sign in" : "Owner's Login"}
          </button>
        ) : (
          !isMobile && (
            <button type="button" onClick={onLogout} className="header-logout-button">
              Logout
            </button>
          )
        )}
      </div>
      <HeaderToolbar user={user} isPublic={isPublic} />
      <NavDrawer
        isOpen={isMenuOpen}
        onClose={closeMenu}
        isPublic={isPublic}
        isAdmin={isAdmin}
        isMobile={isMobile}
        user={user}
        onNavigate={handleNavigate}
        onLogout={handleLogout}
      />
    </header>
  );
}

export default Header;